import { useRegisterSW } from 'virtual:pwa-register/react'

export interface ServiceWorkerState {
  needRefresh: boolean
  offlineReady: boolean
  updateServiceWorker: () => Promise<void>
  close: () => void
}

export function useServiceWorker(): ServiceWorkerState {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      console.log('[SW] Service worker registered:', registration)
    },
    onRegisteredSW(swUrl, registration) {
      console.log('[SW] Service worker registered at:', swUrl)
      // Check for updates every hour
      if (registration) {
        setInterval(() => {
          console.log('[SW] Checking for updates...')
          registration.update()
        }, 60 * 60 * 1000)
      }
    },
    onRegisterError(error) {
      console.error('[SW] Service worker registration failed:', error)
    },
    onNeedRefresh() {
      console.log('[SW] New content available, refresh needed')
    },
    onOfflineReady() {
      console.log('[SW] App ready for offline use')
    },
  })

  const close = () => {
    setNeedRefresh(false)
    setOfflineReady(false)
  }

  return {
    needRefresh,
    offlineReady,
    updateServiceWorker: () => updateServiceWorker(true),
    close,
  }
}
